import { customerAttachmentsSlice } from "./customerSlice";
import * as actions from "./customerActions";
import * as selectors from "./customerSelectors";

export { actions };
export { selectors };

export default customerAttachmentsSlice.reducer;
